/**
 * Relleno de los huecos de una plantilla.  (spec 056 · FR-003, FR-004)
 */
export interface CitaPlantilla {
    nombre: string
    fecha: string
    hora: string
    trabajador: string
}

const ROTULO: Record<string, string> = {
    nombre: 'Nombre',
    fecha: 'Fecha',
    hora: 'Hora',
    trabajador: 'Trabajador',
    '1': 'Nombre',
    '2': 'Fecha',
    '3': 'Hora',
    '4': 'Trabajador',
}

const POR_NOMBRE: Record<string, keyof CitaPlantilla> = {
    nombre: 'nombre',
    fecha: 'fecha',
    hora: 'hora',
    trabajador: 'trabajador',
    '1': 'nombre',
    '2': 'fecha',
    '3': 'hora',
    '4': 'trabajador',
}

export function rotuloHueco(hueco: string): string {
    return ROTULO[hueco] ?? hueco
}

export function rellenarHuecos(huecos: string[], cita: CitaPlantilla | null): Record<string, string> {
    const valores: Record<string, string> = {}
    for (const h of huecos) {
        const campo = POR_NOMBRE[h]
        valores[h] = cita && campo ? cita[campo] : ''
    }
    return valores
}

export function sePuedeEnviar(huecos: string[], valores: Record<string, string>): boolean {
    return huecos.every((h) => (valores[h] ?? '').trim().length > 0)
}
